import Fund from "./fund";

export default class FundAllocation {
    fund: Fund;
    percentage: number;
    amount: number;

    constructor(fund: Fund, percentage: number, amount: number) {
        this.fund = fund;
        this.percentage = percentage;
        this.amount = amount;
    }
}
